<template>
  <div class="CAll">
    <div class="header">
      <div class="header-left">
        <div class="logo-container" @click="backIndex">
          <div style="display: flex;flex-direction: column;">
            <div class="bhText" style="margin-bottom: 4px;">佰衡集团CRM</div>
            <div class="bhDesc">Baiheng (Hebei) Enterprise Management Group Co., Ltd.</div>
          </div>
        </div>
      </div>
      <div class="header-right">
        <div class="user-operate-row">
          <!-- 如果不是index页，才显示待办提醒图标 -->
          <div class="icon-wrap" @click="openTodo" v-if="$route.path !== '/index'&&$route.path !== '/system'">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
            <span v-if="todoCount > 0" class="badge">{{ todoCount > 99 ? '99+' : todoCount }}</span>
            <span class="icon-text">待办提醒</span>
          </div>
          <!-- 只有admin用户才显示系统管理入口 -->
          <div class="icon-wrap" @click="openSystem" v-if="isAdmin">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
            <span class="icon-text">系统管理</span>
          </div>
          <div class="user-dropdown" @click="toggleDropdown">
            <div class="user-avatar">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <span class="user-name">{{ userInfo.name }}</span>
            <svg class="dropdown-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
          <div v-show="showDropdown" class="dropdown-menu" @click.stop>
            <div class="staff-switch-section" v-if="hasManagerRole">
              <div class="staff-section-title">切换员工</div>
              <div class="staff-search-row">
                <el-input v-model="staffSearchKeyword" size="mini" placeholder="搜索姓名/手机号" clearable prefix-icon="el-icon-search" />
              </div>
              <div class="staff-list-scroll">
                <div class="dropdown-item staff-item staff-item-all" :class="{ 'is-current': !currentUserId }"
                  @click="switchStaff(null)">
                  <div class="staff-avatar-sm all-avatar">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </div>
                  <div class="staff-info-wrap">
                    <div class="staff-name-row">
                      <span class="staff-sm-name">{{ isSuperAdmin ? '全部员工' : '全部下级' }}</span>
                      <i v-if="!currentUserId" class="el-icon-check staff-current-icon"></i>
                    </div>
                    <div class="staff-sub-row">
                      <span class="staff-dept">{{ isSuperAdmin ? '不区分角色' : '查看所有下级' }}</span>
                    </div>
                  </div>
                </div>
                <div v-for="(staff, sIdx) in filteredStaffList" :key="staff.userId || staff.id || sIdx"
                  class="dropdown-item staff-item"
                  :class="{ 'is-current': (staff.userId || staff.id) === currentUserId }"
                  @click="switchStaff(staff)">
                  <div class="staff-avatar-sm">{{ (staff.nickName || staff.userName || '?').charAt(0) }}</div>
                  <div class="staff-info-wrap">
                    <div class="staff-name-row">
                      <span class="staff-sm-name">{{ staff.nickName || staff.userName || '-' }}</span>
                      <i v-if="(staff.userId || staff.id) === currentUserId" class="el-icon-check staff-current-icon"></i>
                    </div>
                    <div class="staff-sub-row">
                      <span v-if="staff.deptName" class="staff-dept">{{ staff.deptName }}</span>
                      <span v-if="staff.phonenumber" class="staff-phone">{{ staff.phonenumber }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="filteredStaffList.length === 0 && staffSearchKeyword && !staffLoading" class="staff-empty">没有匹配的员工</div>
                <div v-if="staffLoading" class="staff-empty">加载中...</div>
              </div>
              <div class="dropdown-divider"></div>
            </div>
            <!-- <div class="dropdown-item" @click="openProfile">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                            <span>个人中心</span>
                        </div> -->
            <div class="dropdown-divider"></div>
            <div class="dropdown-item" @click="handleLogout">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span>退出登录</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="emptyContent"></div>

    <div class="maincontent">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { getToken, removeToken, TokenKey } from '@/utils/auth';
import Cookies from "js-cookie";
import { getTodoStatusStatistics, mockLogin, getStaffList } from '@/api/base/enterpriseInfo';
import { getInfo } from '@/api/login';
export default {
  data() {
    return {
      isLogin: false,
      currentDate: '',
      greeting: '',
      userInfo: {
        name: '',
        roles: []
      },
      todoCount: 0,
      emailCount: 12,
      showDropdown: false,
      isAdmin: false,
      staffList: [],
      staffSearchKeyword: '',
      staffLoading: false,
      currentSelectedUserId: null,
      // 当前用户的下级员工 ID 列表（fg 分管角色专用，从 subordinate 字段解析）
      subordinateIds: []
    };
  },
  computed: {
    hasManagerRole() {
      // 优先从 localStorage.managerRoles 取（切换员工后不会被下级 roles 覆盖）
      const rolesStr = localStorage.getItem('managerRoles');
      let roles = [];
      try { roles = rolesStr ? JSON.parse(rolesStr) : (this.userInfo.roles || []); }
      catch (e) { roles = this.userInfo.roles || []; }
      return roles.some(r => {
        const str = typeof r === 'string'
          ? r
          : (r.roleKey || r.roleName || r.name || r.role || r.roleId || '');
        const lower = String(str).toLowerCase();
        return lower === 'admin' || lower === 'fg' || lower === '分管';
      }) || (this.userInfo.userName || this.userInfo.name || '').toLowerCase() === 'admin';
    },
    // 是否为超管 admin（admin 看全部员工，fg 只看下级）
    isSuperAdmin() {
      const rolesStr = localStorage.getItem('managerRoles');
      let roles = [];
      try { roles = rolesStr ? JSON.parse(rolesStr) : (this.userInfo.roles || []); }
      catch (e) { roles = this.userInfo.roles || []; }
      return roles.some(r => {
        const str = typeof r === 'string'
          ? r
          : (r.roleKey || r.roleName || r.name || r.role || r.roleId || '');
        return String(str).toLowerCase() === 'admin';
      }) || (this.userInfo.userName || this.userInfo.name || '').toLowerCase() === 'admin';
    },
    deptList() {
      return [...new Set(this.staffList.map(s => s.deptName).filter(Boolean))];
    },
    filteredStaffList() {
      let list = this.staffList;
      if (this.staffSearchKeyword) {
        const kw = this.staffSearchKeyword.toLowerCase();
        list = list.filter(s =>
          (s.nickName || '').toLowerCase().includes(kw) ||
          (s.phonenumber || '').toLowerCase().includes(kw) ||
          (s.userName || '').toLowerCase().includes(kw)
        );
      }
      return list;
    },
    currentUserId() {
      // currentSelectedUserId 为 null 表示「全部员工」模式（admin userId=1）
      // 由 getCurrentUserData（getInfo）设置，与 index.vue 逻辑一致
      return this.currentSelectedUserId;
    }
  },
  mounted() {
    this.isLogin = getToken() ? true : false;
    this.getUserInfoFromCookies();
    this.getCurrentUserData();
    this.updateDate();
    setInterval(this.updateDate, 1000);
    document.addEventListener('click', this.handleOutsideClick);
    this.$root.$on('updateTotals', this.updateTotals);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
    this.$root.$off('updateTotals', this.updateTotals);
  },
  //监听路由的变化


  watch: {
    $route: {
      handler(newVal, oldVal) {
        if (newVal.meta.moduleType) {
          if (newVal.meta.moduleType == 'enterprise') {
            this.updateTotals('enterprise');
          } else {
            this.updateTotals('talent');
          }
        }
      },
      immediate: true
    }
  },

  methods: {
    // 更新layout的数量
    updateTotals() {
      if (this.$route.meta.moduleType === 'enterprise') {
        getTodoStatusStatistics({
          pageNum: 1,
          pageSize: 1,
        }).then(res => {
          if (res.code === 200) {
            this.todoCount = res.total;
          }
        })
      } else {
        console.log("跟新本人人才的待办数量")
      }
    },
    backIndex() {
      window.location.href = '/index';
    },
    openTodo() {
      console.log('打开待办提醒');
      if (this.$route.meta.moduleType === 'enterprise') {
        this.$router.push({
          path: '/follow-up',
          query: {
            tab: 'todo'
          }
        });
      } else {
        console.log("跟新本人人才的待办数量")
      }
    },
    openSystem() {
      this.$router.push({ path: '/system' });
    },
    openEmail() {
      console.log('打开邮箱消息');
    },
    getUserInfoFromCookies() {
      const userInfoStr = Cookies.get('userInfo');
      if (userInfoStr) {
        this.userInfo = JSON.parse(userInfoStr)
        // 判断是否为 admin 用户
        const roles = this.userInfo.roles || [];
        this.isAdmin = roles.some(r => (r.roleName || r.name || r || '').toLowerCase() === 'admin')
          || (this.userInfo.userName || this.userInfo.name || '').toLowerCase() === 'admin';
        // getStaff 移到 getCurrentUserData 中 subordinateIds 解析完成后调用，避免时序问题
      }
    },
    getCurrentUserData() {
      // 与 index.vue getCurrentUserData 一致：getInfo 获取当前登录用户
      getInfo().then(res => {
        if (res.code === 200 && res.user) {
          // 判断当前返回的是否为管理者身份（admin/fg）
          // RuoYi 的 getInfo 返回 roles 在顶层 res.roles（字符串数组），res.user.roles 可能是对象数组
          const resRoles = res.roles && res.roles.length ? res.roles : (res.user.roles || []);
          const isManagerRes = resRoles.some(r => {
            const str = typeof r === 'string' ? r : (r.roleKey || r.roleName || r.name || '');
            return ['admin', 'fg'].includes(String(str).toLowerCase());
          });
          let subStr = '';
          if (isManagerRes) {
            // 管理者身份：保存 subordinate、userId、roles 到 localStorage，供切换后恢复使用
            subStr = res.user.subordinate || '';
            localStorage.setItem('managerSubordinate', subStr);
            localStorage.setItem('managerUserId', res.user.userId);
            localStorage.setItem('managerRoles', JSON.stringify(resRoles));
          } else {
            // 已切换到下级员工身份：从 localStorage 恢复原始管理者的 subordinate
            subStr = localStorage.getItem('managerSubordinate') || '';
          }
          this.subordinateIds = subStr
            ? subStr.split('、').map(id => Number(id)).filter(id => !isNaN(id) && id > 0)
            : [];
          // 更新显示字段（不覆盖 roles，保留原始管理者角色）
          this.userInfo = {
            ...this.userInfo,
            name: res.user.nickName || res.user.userName || res.user.name,
            nickName: res.user.nickName,
            userName: res.user.userName,
            userId: res.user.userId,
            phonenumber: res.user.phonenumber,
            subordinate: subStr
          };
          if (res.user.userId == '1' || res.user.userId === 1) {
            this.currentSelectedUserId = null;
          } else {
            this.currentSelectedUserId = res.user.userId || res.user.id;
          }
          // subordinateIds 解析完成后再加载员工列表（fg 用户需按 subordinateIds 过滤）
          if (this.hasManagerRole) {
            this.getStaff();
          }
        }
      }).catch(() => {});
    },
    getStaff() {
      this.staffLoading = true;
      getStaffList().then(res => {
        if (res.code === 200) {
          const allStaff = res.data || [];
          // 判断员工是否为 fg 分管角色
          const isFgRole = (staff) => {
            const roles = staff.roles || [];
            return roles.some(r => {
              const str = typeof r === 'string' ? r : (r.roleKey || r.roleName || r.name || '');
              return String(str).toLowerCase() === 'fg';
            });
          };
          // admin 超管看全部员工（屏蔽 fg 分管角色）；fg 分管只看自己的下级员工（subordinateIds）
          if (this.isSuperAdmin) {
            this.staffList = allStaff.filter(s => !isFgRole(s));
          } else {
            this.staffList = allStaff.filter(s => {
              const uid = s.userId || s.id;
              return this.subordinateIds.includes(Number(uid));
            });
          }
        }
      }).finally(() => {
        this.staffLoading = false;
      });
    },

    updateDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      if (hours >= 6 && hours < 12) {
        this.greeting = '上午好';
      } else if (hours >= 12 && hours < 18) {
        this.greeting = '下午好';
      } else if (hours >= 18 && hours < 24) {
        this.greeting = '晚上好';
      } else {
        this.greeting = '夜深了';
      }

      this.currentDate = `${year}-${month}-${day} ${String(hours).padStart(2, '0')}:${minutes}:${seconds}`;
    },
    toggleDropdown(event) {
      event.stopPropagation();
      this.showDropdown = !this.showDropdown;
    },
    handleOutsideClick() {
      this.showDropdown = false;
    },
    openProfile() {
      this.showDropdown = false;
      console.log('打开个人中心');
    },
    switchStaff(staff) {
      this.showDropdown = false;
      // staff === null 表示「全部下级」，切换回原始管理者账号，而非 admin
      const isAll = !staff;
      const managerUserId = localStorage.getItem('managerUserId');
      const targetUserId = isAll
        ? (managerUserId ? Number(managerUserId) : 1)
        : (staff.userId || staff.id || 1);
      const displayName = isAll ? (this.isSuperAdmin ? '全部员工' : '全部下级') : (staff.nickName || staff.userName || staff.name);
      // 对齐 index.vue confirmSelect：只换 token，不写 userInfo
      // Cookies 中的 userInfo 保留管理者信息，hasManagerRole 始终为 true
      mockLogin({ userId: targetUserId }).then(res => {
        if (res.code === 200) {
          const date = new Date();
          date.setTime(date.getTime() + (10 * 365 * 24 * 60 * 60 * 1000));
          Cookies.set(TokenKey, res.data.token, { expires: date });
          localStorage.setItem('AccessToken_expriesTime', date);
        }
      }).finally(() => {
        this.$message.success(`已切换到：${displayName}`);
        // 重定向并刷新工作台
        window.location.href = '/index';
      });
    },
    handleLogout() {
      removeToken();
      localStorage.removeItem('AccessToken_expriesTime');
      localStorage.removeItem('managerSubordinate');
      localStorage.removeItem('managerUserId');
      localStorage.removeItem('managerRoles');
      Cookies.remove('userInfo');
      location.href = '/loginPage';
    }
  }
};
</script>

<style lang="scss" scoped>
// 高级配色方案
$primary-color: #165DFF;
$primary-light: #4080FF;
$primary-dark: #0E42B4;
$primary-gradient: linear-gradient(135deg, $primary-color 0%, $primary-light 100%);

$success-color: #00B42A;
$success-light: #36D399;
$success-gradient: linear-gradient(135deg, $success-color 0%, $success-light 100%);

$warning-color: #FF7D00;
$warning-light: #FFB020;
$warning-gradient: linear-gradient(135deg, $warning-color 0%, $warning-light 100%);

$info-color: #722ED1;
$info-light: #9254DE;
$info-gradient: linear-gradient(135deg, $info-color 0%, $info-light 100%);

// 文本颜色
$text-primary: #1D2129;
$text-secondary: #4E5969;
$text-muted: #86909C;
$text-light: #F2F3F5;

// 边框颜色
$border-color: #E5E6EB;
$border-light: #F2F3F5;
$border-dark: #C9CDD4;

// 背景颜色
$bg-primary: #F7F8FA;
$bg-secondary: #F2F3F5;
$bg-white: #FFFFFF;
$bg-hover: #F9FAFB;

// 阴影效果
$shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
$shadow-md: 0 4px 12px 0 rgba(0, 0, 0, 0.08);
$shadow-lg: 0 10px 20px 0 rgba(0, 0, 0, 0.12);
$shadow-xl: 0 20px 30px 0 rgba(0, 0, 0, 0.15);

// 边框半径
$border-radius-sm: 6px;
$border-radius-md: 8px;
$border-radius-lg: 12px;
$border-radius-xl: 16px;

// 字体设置
$font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
$font-mono: 'SF Mono', 'Monaco', 'Courier New', monospace;

// 动画设置
$transition-fast: 0.2s ease;
$transition-normal: 0.3s ease;
$transition-slow: 0.4s cubic-bezier(0.4, 0, 0.2, 1);

.CAll {
  min-width: 1280px;
  background: linear-gradient(135deg, #F7F8FA 0%, #E8F0FE 100%);
}

.header {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(229, 230, 235, 0.8);
  padding: 0 60px;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.08);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;

  .header-left {
    display: flex;
    align-items: center;
    gap: 60px;

    .logo-container {
      display: flex;
      align-items: center;
      gap: 16px;
      position: relative;
      cursor: pointer;

      .logo-icon {
        width: 55px;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        color: white;
        transition: all $transition-slow;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transform: rotate(45deg);
          animation: shine 3s infinite;
        }
      }
    }
  }

  .header-right {
    .user-operate-row {
      display: flex;
      align-items: center;
      gap: 20px;

      .icon-wrap {
        display: flex;
        align-items: center;
        gap: 6px;
        position: relative;
        cursor: pointer;
        color: $text-secondary;
        padding: 8px 12px;
        border-radius: $border-radius-md;
        transition: all $transition-fast;

        &:hover {
          background: rgba(22, 93, 255, 0.08);
          color: $primary-color;
        }

        .icon-text {
          font-size: 13px;
          font-weight: 500;
        }

        .badge {
          position: absolute;
          top: 2px;
          right: 0px;
          min-width: 18px;
          height: 18px;
          line-height: 18px;
          padding: 0px;
          background-color: #F53F3F;
          color: #fff;
          font-size: 11px;
          text-align: center;
          border-radius: 9px;
          box-shadow: 0 0 0 2px #fff;
          animation: badgePulse 2s infinite;
        }
      }

      .user-dropdown {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 12px;
        border-radius: $border-radius-md;
        cursor: pointer;
        transition: all $transition-fast;
        color: $text-secondary;

        &:hover {
          background: rgba(242, 243, 245, 0.9);
          color: $text-primary;

          .dropdown-arrow {
            transform: rotate(180deg);
          }
        }

        .user-avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: $primary-gradient;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 2px 8px rgba(22, 93, 255, 0.3);
        }

        .user-name {
          font-size: 14px;
          font-weight: 500;
          white-space: nowrap;
        }

        .dropdown-arrow {
          color: $text-muted;
          transition: transform $transition-fast;
          flex-shrink: 0;
        }
      }

      .dropdown-menu {
        position: absolute;
        top: calc(100% + 8px);
        right: 60px;
        min-width: 280px;
        background: #fff;
        border-radius: $border-radius-lg;
        box-shadow: $shadow-lg;
        border: 1px solid $border-color;
        padding: 4px 0;
        z-index: 1000;
        animation: dropdownFadeIn 0.2s ease;

        .staff-switch-section {
          padding: 8px 4px 4px 4px;
          .staff-section-title {
            font-size: 12px;
            font-weight: 600;
            color: $text-muted;
            padding: 4px 16px 8px 16px;
            letter-spacing: 0.5px;
          }
          .staff-search-row {
            padding: 0 12px 8px 12px;
          }
          .staff-list-scroll {
            max-height: 320px;
            min-height: 40px;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 2px 0;
            margin-right: 2px;

            &::-webkit-scrollbar {
              width: 6px;
            }

            &::-webkit-scrollbar-thumb {
              background: #C9CDD4;
              border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb:hover {
              background: #86909C;
            }

            &::-webkit-scrollbar-track {
              background: transparent;
            }
          }
          .staff-item {
            display: flex !important;
            align-items: flex-start !important;
            gap: 10px !important;
            padding: 8px 16px !important;
            margin: 0 4px 2px 4px;
            border-radius: 6px;

            &.is-current {
              background: rgba(22, 93, 255, 0.06);
              .staff-sm-name {
                color: $primary-color;
                font-weight: 600;
              }
            }

            .staff-avatar-sm {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background: $primary-gradient;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              font-weight: 600;
              flex-shrink: 0;

              &.all-avatar {
                background: linear-gradient(135deg, #722ED1 0%, #9254DE 100%);
                color: #fff;
                svg {
                  color: #fff;
                }
              }
            }
            .staff-info-wrap {
              flex: 1;
              min-width: 0;
            }
            .staff-name-row {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .staff-sm-name {
                font-size: 14px;
                color: $text-primary;
              }
              .staff-current-icon {
                color: $primary-color;
                font-size: 14px;
                font-weight: 700;
              }
            }
            .staff-sub-row {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 12px;
              color: $text-muted;
              margin-top: 2px;
              overflow: hidden;
              .staff-dept {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .staff-phone {
                flex-shrink: 0;
              }
            }
          }
          .staff-empty {
            padding: 16px 20px;
            text-align: center;
            font-size: 12px;
            color: $text-muted;
          }
        }

        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 16px;
          font-size: 14px;
          color: $text-secondary;
          cursor: pointer;
          transition: all $transition-fast;

          &:hover {
            background: rgba(22, 93, 255, 0.08);
            color: $primary-color;
          }
        }

        .dropdown-divider {
          height: 1px;
          background: $border-light;
          margin: 4px 0;
        }
      }
    }
  }
}

.emptyContent {
  height: 70px;
}

@keyframes shine {
  0% {
    transform: translateX(-100%) rotate(45deg);
  }

  100% {
    transform: translateX(100%) rotate(45deg);
  }
}

@keyframes badgePulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.08);
  }
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1280px) {
  .header {
    padding: 0 40px;
    height: 80px;

    .header-left {
      gap: 40px;

      .logo-container {
        gap: 14px;

        .logo-icon {
          height: 60px;
        }
      }
    }
  }

  .emptyContent {
    height: 80px;
  }
}

@media (max-width: 768px) {
  .CAll {
    min-width: 100%;
  }

  .header {
    padding: 0 20px;
    height: auto;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    gap: 16px;

    .header-left {
      width: 100%;

      .logo-container {
        width: 100%;
        justify-content: space-between;
        align-items: center;
      }
    }

    .header-right {
      width: 100%;

      .user-operate-row {
        width: 100%;
        justify-content: center;
        flex-wrap: wrap;
        gap: 12px;
      }
    }
  }

  .emptyContent {
    height: auto;
    padding: 20px 0;
  }
}

.maincontent {
  background-color: #FFFFFF;
}

.bhText {
  font-size: 18px;
  font-weight: 550;
}

.bhDesc {
  font-size: 12px;
  color: #333333;
}
</style>
